import { renderCards, renderWinClass } from '../../utils/cards';

type Props = {
  winner: boolean;
  score: number;
  cards: any;
  who: any;
};

const GameCards = ({ winner, score, cards, who }: Props) => {
  return (
    <div className={`game__cards game__cards--${who} ${renderWinClass(winner)}`}>
      <p>{score}</p>
      <div className="game__deck">{renderCards(cards)}</div>
      <p>{who}</p>
    </div>
  );
};

export default GameCards;
